export default __webpack_public_path__ + "static/media/icon-no-result.71ca0436.png";